// Libraries
import { action, computed, observable } from "mobx";

// Core
import { FieldType } from "Core/Utils/Utils";
import { ViewModelBase } from "Core/ViewModels";

// Custom
import { Server } from "Custom/Globals/AppUrls";
import { ProgressActivityModel, ProgressActivityModelDTO } from "Custom/Models/DashboardModels/ProgressActivityModel";
import { ProgressModel } from "Custom/Models/DashboardModels/ProgressModel";
import { ApiStatus } from "Custom/Models/Enums/ApiStatus";
import { StoresInstance } from "../../Stores";

export class ProgressViewModel extends ViewModelBase<ProgressModel> {
    constructor(propertyId: string) {
        super(new ProgressModel());
        this.setDecorators(ProgressModel);

        //console.log("PROGRESSSVM CONSTRUCTOR: PropertyId", propertyId);
        this.propertyId = propertyId;

        if (propertyId !== null && propertyId !== undefined && propertyId !== "") {
            this.load(propertyId);
        }
    }

    // #region Properties

    @observable
    public propertyId: string = "";

    @observable
    public apiStatus: ApiStatus = ApiStatus.loading;

    // #endregion Properties

    // #region Computeds

    @computed
    public get Activities() {
        return this.model.activities;
    }

    @computed
    public get hasActivities() {
        return this.Activities !== null && this.Activities !== undefined && this.Activities.length > 0;
    }

    @action
    public SalesStatus = (salesStatusId: string) => {
        let salesStatus: ProgressActivityModel | undefined = undefined;

        if (salesStatusId) {
            const activitySalesStatus = this.model.activities.find(s => s.id == salesStatusId);

            if (activitySalesStatus) {
                salesStatus = activitySalesStatus;
            }
        }

        return salesStatus;
    };

    @computed
    public get ApiStatus(): ApiStatus {
        return this.apiStatus;
    }

    @computed
    public get latestActivityId(): string {
        let id = "";
        Array.from(this.Activities)
            .sort((a: any, b: any) => b.completedDate - a.completedDate)
            .find(a => {
                const sa = Array.from(a.Activities)
                    .reverse()
                    .find(sa => sa.isCompleted);
                if (sa) {
                    id = sa.getValue("id");
                    return true;
                }
                if (a.getValue<boolean>("isCompleted")) {
                    id = a.getValue("id");
                    return true;
                }
                return false;
            });
        return id;
    }

    // #endregion Computeds

    // #region Actions

    @action
    public setApiStatus(apiStatus: ApiStatus) {
        this.apiStatus = apiStatus;
    }

    public navigateToDashboard = () => {
        this.history.push(`/${this.propertyId}`);
    };

    private load = async (id: string): Promise<void> => {
        this.setApiStatus(ApiStatus.loading);

        try {
            const apiResult = await this.Get<ProgressActivityModelDTO[]>(Server.Api.Dashboard.GetProgress + "/" + id);

            if (apiResult.wasSuccessful) {
                this.model.fromDto(apiResult.payload);
                this.setApiStatus(ApiStatus.success);
            } else {
                this.setApiStatus(ApiStatus.error);
            }
        } catch (exception) {
            this.setApiStatus(ApiStatus.error);
        } finally {
            // Finally
        }
    };

    // #endregion Actions

    // #region Boilerplate

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public isFieldValid(fieldName: keyof FieldType<any>): boolean {
        return true;
    }

    // #endregion Boilerplate
}
